import { render, staticRenderFns } from "./main-container.vue?vue&type=template&id=5d7dfd8c&"
import script from "./main-container.vue?vue&type=script&lang=ts&"
export * from "./main-container.vue?vue&type=script&lang=ts&"
import style0 from "./main-container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports